const C = {
  name: "PayLater",
  dimensions: { width: 24, height: 24 },
  content: `
    <svg fill="currentColor">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M18 14C18 13.4477 17.5523 13 17 13C16.4477 13 16 13.4477 16 14V16C16 16.5523 16.4477 17 17 17H19C19.5523 17 20 16.5523 20 16C20 15.4477 19.5523 15 19 15H18V14Z" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M3 1C1.34772 1 0 2.34772 0 4V11C0 12.6523 1.34772 14 3 14H10.2899C10.1013 14.6337 10 15.305 10 16C10 19.866 13.134 23 17 23C20.866 23 24 19.866 24 16C24 12.134 20.866 9 17 9V4C17 2.34772 15.6523 1 14 1H3ZM15 9.28988C13.4647 9.74682 12.1501 10.7163 11.2547 12H3C2.45228 12 2 11.5477 2 11V7H15V9.28988ZM15 5V4C15 3.45228 14.5477 3 14 3H3C2.45228 3 2 3.45228 2 4V5H15ZM17 11C14.2386 11 12 13.2386 12 16C12 18.7614 14.2386 21 17 21C19.7614 21 22 18.7614 22 16C22 13.2386 19.7614 11 17 11Z" />
    </svg>
  `
};
export {
  C as PayLater
};
